var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 2C12.1642 2 12.5 2.33579 12.5 2.75L12.5 18.9393L18.2197 13.2197C18.5126 12.9268 18.9874 12.9268 19.2803 13.2197C19.5732 13.5126 19.5732 13.9874 19.2803 14.2803L12.2803 21.2803C11.9874 21.5732 11.5126 21.5732 11.2197 21.2803L4.21967 14.2803C3.92678 13.9874 3.92678 13.5126 4.21967 13.2197C4.51256 12.9268 4.98744 12.9268 5.28033 13.2197L11 18.9393L11 2.75C11 2.33579 11.3358 2 11.75 2Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.6c8ec8dd6da21b26cf84f6047c0ce8eb.svg";
export { ForwardRef as ReactComponent };